<template>
<div>
   <h2>
       <div>{{ $t("topEventParticipantsView.topParticipants", [numTop]) }}</div>
       <div>{{ getCurrentSeasonYears() }}</div>
   </h2> 
   <table>
       <thead>
           <tr>
             <th></th>
             <th></th>
             <th></th>
           </tr>
       </thead>
       <tbody>
           <tr v-for="(s, i) in sponsorships"
               :key="s.user.userId"
               :class="{ hilight: s.user.userId == store.currentUser.userId }">

               <td>{{ i + 1 }}</td>
               <td>{{ s.user.fullName }}</td>
               <td>{{ $n(s.totalSponsorshipAmount, "currency") }}</td>
           </tr>
           <tr v-if="userPos == -1">
               <td>...</td>
               <td></td>
               <td></td>
           </tr>
           <tr class="hilight" v-if="userPos == -1">
               <td>-</td>
               <td>{{ store.currentUser.fullName }}</td>
               <td>{{ $n(userSponsorshipAmount, "currency") }}</td>
           </tr>
       </tbody>
   </table>
</div>
</template>

<script lang="ts">
import { store, UserSponsorship } from "store";
import axios from "axios";
import { defineComponent } from "vue";

interface SetupData {
    sponsorships: UserSponsorship[];
    userSponsorshipAmount: number;
    currentUserSponsorship: UserSponsorship;
    userPos: number;
}

export default defineComponent({
    async setup(props): SetupData {
        const sponsorships = (await axios.get<UserSponsorship[]>("eventparticipants/top", {
            params: {
                num: props.numTop,
                fromYear: new Date(Date.now()).getFullYear()
            }
        })).data;

        const userSponsorshipAmount = (await axios.get<number>("eventparticipants/me-total-sponsorship")).data;

        const currentUserSponsorship = sponsorships.find(s => s.user.userId == store.currentUser.userId);
        const userPos = sponsorships.indexOf(currentUserSponsorship);

        return {
            sponsorships,
            currentUserSponsorship,
            userSponsorshipAmount,
            userPos,
        };
    },
    data() {
        return {
            store: store,
        };
    },
    methods: {
        getCurrentSeasonYears() {
            let year = new Date(Date.now()).getFullYear();

            return `${year} - ${year + 1}`;
        }
    },
    props: {
        numTop: {
            type: Number
        }
    }
})
</script>